/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxTextAreaComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtextarea';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcTextAreaComponent),
    multi: true
};

/**
 * Text Area
 */
@Component({
    selector: 'ngc-textarea',
    template: `<jqxTextArea *ngIf="visible" (input)="inputChange($event)"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownWidth] = "dropDownWidth"
                [items] = "items"
                [maxLength] = "maxLength"
                [minLength] = "minLength"
                [opened] = "opened"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [query] = "query"
                [renderer] = "renderer"
                [roundedCorners] = "roundedCorners"
                [rtl] = "rtl"
                [scrollBarSize] = "scrollBarSize"
                [searchMode] = "searchMode"
                [source] = "source"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxTextArea>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcTextAreaComponent extends ControlComponent {
    @Input('displayMember') displayMember: any;
    @Input('dropDownWidth') dropDownWidth: any;
    @Input('items') items: any;
    @Input('maxLength') maxLength: any;
    @Input('minLength') minLength: any;
    @Input('opened') opened: any;
    @Input('placeHolder') placeHolder: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('query') query: any;
    @Input('renderer') renderer: any;
    @Input('roundedCorners') roundedCorners: any;
    @Input('rtl') rtl: any;
    @Input('scrollBarSize') scrollBarSize: any;
    @Input('searchMode') searchMode: any;
    @Input('source') source: any;
    @Input('theme') theme: any;
    @Input('valueMember') valueMember: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
}

/**
 * Text Area Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcTextAreaComponent],
    declarations: [NgcTextAreaComponent, jqxTextAreaComponent]
})
export class NgcTextAreaModule {
}